import { useEffect, useState } from "react";
import { GiphyFetch } from "@giphy/js-fetch-api";

export const usePixabaySearch = ({
  def: defaultCategoryType = "gif",
}: {
  def?: string;
}) => {
  const [query, setQuery] = useState<string>("");
  const [contentType, setContentType] = useState<string>(defaultCategoryType);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>([]);
  const [page, setPage] = useState(1);

  const gf = new GiphyFetch("xXAOGlcYvoC74JKasY0CG4WlbrRR0o2p");

  async function getSearchGifs({offset}: {offset: number}){
    const results = await gf.search(query, { offset, type: "gifs" });
    setData(results.data)
    return (results.data)
  };

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    //@ts-ignore
    getSearchGifs(data.length)
    return () => {
      controller.abort();
    };
  }, [query, contentType]);

  const search = (contentType: string, query: string) => {
    setQuery(query);
    setContentType(contentType);
  };

  const fetchMoreData = async () => {
    setPage(page + 1);
    const results = await gf.search(query, { offset: page});
    setData(results.data)
  };

  return { search, data, loading, fetchMoreData };
};